<template>
	<!-- 修改人员组织 -->
	<div>
		<el-dialog :visible.sync="dataActionBox" title="设置组织" :append-to-body="true">
			<div class='data_page_content'>
				<div class="page_form_box">
					<el-form ref="form" label-position="top" label-width="120px">
						<el-form-item label="组织列表">
							<el-cascader  ref="infoListInput"  :options="allorgList" :props="defaultProps" v-model="sendDataInfo.ormIds"  clearable style="width: 100%;">
								<template slot-scope="{ node, data }">
								    <span>{{ data.label }}</span>
								    <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
								</template>
							</el-cascader>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="demo-drawer__footer">
				<el-button @click="dataActionBox=false">取 消</el-button>
				<el-button type="primary" @click="sendDataAction()">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'setUserOrgAction',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:false,
			sendDataInfo:{
			  "opmId": 0,
			  "ormIds": []
			},
			defaultProps:  { 
				multiple: true,
				expandTrigger:'hover',
				checkStrictly:true,
				emitPath:false,
			},
			allorgList:[],
			
			selectedDataList:[],
			
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		
		openBox(oldData=''){
			this.sendDataInfo.opmId = oldData.opmId
			this.sendDataInfo.ormIds = []
			this.dataActionBox = true
			this.getOrgList()
		},
		
		async getOrgList(){
			var _this = this
			this.allorgList = await this.$common.getALLOrg()
			if(this.allorgList.length>=1){
				_this.sendDataInfo.ormIds = []
				var responseData =  await this.$http.getUserOrg({ids:[this.sendDataInfo.opmId]})
				if(responseData.status == 200){
					console.log(responseData.result)
					if(responseData.result.length>=1){
						responseData.result.forEach(item=>{
							_this.sendDataInfo.ormIds.push(item.ormId)
						})
					}
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
			}
		},
		
		async sendDataAction(){
			var responseData =  await this.$http.settingUserOrg(this.sendDataInfo)
			if(responseData.status == 200){
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.dataActionBox = false
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.el-cascader .el-cascader__tags{
	max-height: 300px !important;
	overflow-y: scroll !important;
}
</style>